import { render } from "./WCCartDrawerSaveForLaterListItem.vue?vue&type=template&id=37062a10&scoped=true"
import script from "./WCCartDrawerSaveForLaterListItem.vue?vue&type=script&lang=js"
export * from "./WCCartDrawerSaveForLaterListItem.vue?vue&type=script&lang=js"

import "./WCCartDrawerSaveForLaterListItem.vue?vue&type=style&index=0&id=37062a10&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37062a10"]])

export default __exports__